import EnumList from "./EnumList";

class LicenseTypes extends EnumList {
  constructor() {
    super();

    this.STANDARD = this.add(0, "Standard");
    this.RENTAL = this.add(1, "Rental");
    //this.TRIAL = this.add(2, "Trial");
  }
}

export default LicenseTypes;



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Enums/LicenseTypes.js